import type { IconDefinition, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckSquare,
  faCircle,
  faEye,
  faFileAlt,
  faFilePdf,
  faKeyboard,
  faListAlt,
  faSquare,
  faUser
} from '@fortawesome/free-regular-svg-icons';
import {
  faAddressBook,
  faAddressCard,
  faAdjust,
  faAnchor,
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faArchive,
  faArrowAltCircleUp,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRotateRight,
  faArrowUpAZ,
  faArrowUpZA,
  faBan,
  faBell,
  faBolt,
  faBook,
  faBookOpen,
  faBriefcase,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartShopping,
  faChalkboardUser,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faChild,
  faCircleInfo,
  faCircleNodes,
  faCircle as faCircleSolid,
  faCircleXmark,
  faClipboard,
  faClockRotateLeft,
  faCloudArrowDown,
  faCloudArrowUp,
  faCompressAlt,
  faCrown,
  faDatabase,
  faDownload,
  faExclamationTriangle,
  faExpandAlt,
  faEyeSlash,
  faFileAlt as faFileAltSolid,
  faHome,
  faInfo,
  faLink,
  faMagnifyingGlass,
  faPenToSquare,
  faPlay,
  faPlus,
  faPlusCircle,
  faPrint,
  faRightLeft,
  faSchool,
  faSitemap,
  faSortDown,
  faSortUp,
  faSpinner,
  faSquare as faSquareSolid,
  faTable,
  faToggleOff,
  faToggleOn,
  faTrashCan,
  faUpload,
  faUserGear,
  faUserPen,
  faUserPlus,
  faUserSecret,
  faUser as faUserSolid,
  faUsers,
  faWrench,
  faXmark
} from '@fortawesome/free-solid-svg-icons';

type Icon = {
  icon: IconDefinition;
  type?: IconPrefix;
};

export const icons: Icon[] = [
  { icon: faAddressCard },
  { icon: faAddressBook },
  { icon: faAdjust },
  { icon: faAnchor },
  { icon: faAnglesLeft },
  { icon: faAnglesRight },
  { icon: faArrowLeft },
  { icon: faArrowRight },
  { icon: faBan },
  { icon: faBook },
  { icon: faChartBar },
  { icon: faChevronLeft },
  { icon: faChevronRight },
  { icon: faCaretDown },
  { icon: faCaretUp },
  { icon: faCaretRight },
  { icon: faCircle },
  { icon: faCircleSolid },
  { icon: faCompressAlt },
  { icon: faCheck },
  { icon: faCheckSquare },
  { icon: faCheckCircle },
  { icon: faCloudArrowUp },
  { icon: faCloudArrowDown },
  { icon: faDatabase },
  { icon: faDownload },
  { icon: faPenToSquare },
  { icon: faEye },
  { icon: faRightLeft },
  { icon: faExclamationTriangle },
  { icon: faExpandAlt },
  { icon: faFilePdf },
  { icon: faFileAlt },
  { icon: faFileAltSolid },
  { icon: faHome },
  { icon: faCircleInfo },
  { icon: faInfo },
  { icon: faKeyboard },
  { icon: faListAlt },
  { icon: faLink },
  { icon: faPlay },
  { icon: faPlus },
  { icon: faPlusCircle },
  { icon: faPrint },
  { icon: faArrowRotateRight },
  { icon: faSitemap },
  { icon: faCartShopping },
  { icon: faSortUp },
  { icon: faSortDown },
  { icon: faArrowRightFromBracket },
  { icon: faSpinner },
  { icon: faSquare },
  { icon: faSquareSolid },
  { icon: faMagnifyingGlass },
  { icon: faXmark },
  { icon: faCircleXmark },
  { icon: faTable },
  { icon: faTrashCan },
  { icon: faToggleOn },
  { icon: faToggleOff },
  { icon: faUser },
  { icon: faUserSolid },
  { icon: faUserSecret },
  { icon: faWrench },
  { icon: faUsers },
  { icon: faUpload },
  { icon: faBolt },
  { icon: faEyeSlash },
  { icon: faUserPen },
  { icon: faUserPlus },
  { icon: faArrowAltCircleUp },
  { icon: faBell },
  { icon: faUserGear },
  { icon: faBookOpen },
  { icon: faSchool },
  { icon: faArrowUpZA },
  { icon: faArrowUpAZ },
  { icon: faAngleRight },
  { icon: faAngleLeft },
  { icon: faCrown },
  { icon: faBriefcase },
  { icon: faChild },
  { icon: faChalkboardUser },
  { icon: faArchive },
  { icon: faClockRotateLeft },
  { icon: faChartLine },
  { icon: faCircleNodes },
  { icon: faClipboard }
];

export default (): void => {
  icons.forEach((icon) => {
    library.add(icon.icon);
  });
};
